import React from "react";
import { Routes, Route } from "react-router-dom";
import { Empresa, Empresas, EmpresasSetor, ListaEmpresas } from "../../../pagesPublic";
import { ROUTES_SETORES } from "../../../enums";

const EmpresasRoutes = () => {
  return (
    <Routes>
      <Route exact path={"busca/page/:page"} element={<Empresas />} />
      <Route exact path={"busca"} element={<Empresas />} />
      {Object.keys(ROUTES_SETORES).map(pRoute => (
        <React.Fragment key={pRoute}>
          <Route exact path={`${pRoute}/page/:page`} element={<EmpresasSetor />} />
          <Route exact path={pRoute} element={<EmpresasSetor />} />
        </React.Fragment>
      ))}
      <Route exact path={`:pessoa_id/*`} element={<Empresa />} />
      <Route path={"*"} element={<ListaEmpresas />} />
    </Routes>
  );
};

export default EmpresasRoutes;
